import { render, staticRenderFns } from "./BusInspectionBaseList.vue?vue&type=template&id=c1525f26&scoped=true&"
import script from "./BusInspectionBaseList.vue?vue&type=script&lang=js&"
export * from "./BusInspectionBaseList.vue?vue&type=script&lang=js&"
import style0 from "./BusInspectionBaseList.vue?vue&type=style&index=0&id=c1525f26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1525f26",
  null
  
)

export default component.exports